import { logFormData } from 'shared/lib/logFormData';
import type { TFormAnalyticsEventsOverrides } from 'shared/types/TFormAnalyticsEventsOverrides';

import type { TWorkplaceFormFields } from 'entities/creditForm';
import { setWorkplaceInfo, sendStepsAnalyticsEvents } from 'entities/creditForm';

import { WorkplaceInfoTexts } from 'features/UpdateWorkplaceInfo';

export const submitWorkplaceForm =
  (actualData: TWorkplaceFormFields, analyticsOverrides?: TFormAnalyticsEventsOverrides): ThunkResult<void> =>
  async (dispatch) => {
    logFormData('WorkplaceInfo FormStep SubmitData', actualData);
    dispatch(sendStepsAnalyticsEvents([3], WorkplaceInfoTexts, 'manual', analyticsOverrides));
    dispatch(setWorkplaceInfo({ data: actualData, isFullFilled: true }));
  };
